import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faIgloo, faLowVision, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from 'react-toastify';
import RouterInner from './router/Router';
import 'react-toastify/dist/ReactToastify.css';

library.add(faIgloo, faLowVision, faUserSlash);

function App() {
  return (
    <div>
      <ToastContainer autoClose={8000} />
      <RouterInner />
    </div>
  );
}

export default App;
